module.exports = __webpack_public_path__ + "img/manja_vitolic_gkxkby_Gwk1A.6b07b4f3.jpg";